import { Permission } from '@cims-online/shared'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import {
  Organization,
  useOrganizationsTableContext,
} from '../../../../OrganizationsTableContext'
import { useRemoveOrganizationMutation } from 'schema'

export function useRemoveOptions(): RemoveRowActionOptions<Organization> {
  const { refetch } = useOrganizationsTableContext()
  const [removeOrganization] = useRemoveOrganizationMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveDSOrganization: {
        organization: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    disabled: ({ submittals }) =>
      !!submittals.length
        ? {
            message:
              'Organizations cannot be deleted if they are associated with one or more Design Submittals',
          }
        : false,
    permission: Permission.RemoveRestoreDesignSubmittalOrganization,
    onRemove: async ({ id }) => {
      await removeOrganization({ variables: { id } })
      refetch()
    },
  }
}
